import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import { Profile } from "./components/Profile/Profile";
import { Technologies } from "./components/Technologies/Technologies";
import { LoadingHome } from "./components/LoadingHome/LoadingHome";

import estebanCaccinStyles from "./estebanCaccin.module.scss";
import { useLoadingHome } from "./components/LoadingHome/useLoadingHome";
import { ProvideAuthContext } from "./components/AuthContext/AuthContext";

export const EstebanCaccin: React.FC<RouteProps> = () => {
  const { loading, isLoadingHome } = useLoadingHome({ time: 4000 });

  useEffect(() => {
    loading();
  }, []);

  return isLoadingHome ? (
    <LoadingHome />
  ) : (
    <div
      className={`bg-dark pt-5 w-100 ${estebanCaccinStyles["container-esteban-caccin"]}`}>
      <ProvideAuthContext>
        <Container>
          <Profile />
          <Technologies />
        </Container>
      </ProvideAuthContext>
    </div>
  );
};
export default new Content({
  Component: EstebanCaccin,
  title: "Esteban Caccin",
  route: "esteban-caccin",
  tags: ["frontend", "react", "node", "bootstrap", "javascript", "css", "html"]
});
